function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { Tooltip } from "@carbon/react";
import { Information } from "@carbon/react/icons";
import IntegrationPropertySelect from "./IntegrationPropertySelect";
import CustomTextInput from "./CustomTextInput";
import { i18nContext } from "../table-context";
export default function IntegrationContent(_ref) {
  var isLoadingToolchainServices = _ref.isLoadingToolchainServices,
    property = _ref.property,
    updateProperty = _ref.updateProperty,
    validationErrors = _ref.validationErrors;
  var i18n = useContext(i18nContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IntegrationPropertySelect, {
    isLoading: isLoadingToolchainServices,
    property: property,
    updateProperty: updateProperty
  }), /*#__PURE__*/React.createElement(CustomTextInput, {
    autoComplete: "new-password",
    "data-type": property.type,
    id: "property-panel-integration-path",
    invalid: !!validationErrors["custom:path"],
    invalidText: validationErrors["custom:path"],
    labelText: /*#__PURE__*/React.createElement(React.Fragment, null, i18n.messages.integrationPathLabel, /*#__PURE__*/React.createElement(Tooltip, {
      align: "top-left",
      className: "ocr--integration-tooltip",
      label: i18n.messages.integrationPathTooltip
    }, /*#__PURE__*/React.createElement("button", {
      className: "ocr--tooltip-trigger",
      type: "button"
    }, /*#__PURE__*/React.createElement(Information, null)))),
    onChange: function onChange(path) {
      return updateProperty(_objectSpread(_objectSpread({}, property), {}, {
        path: path
      }));
    },
    placeholder: i18n.messages.integrationPathPlaceholder,
    spellCheck: "false",
    type: "text",
    value: property.path
  }));
}